import React from 'react';
import { Box, Typography, FormControl, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { behaviorQuestions } from '../../data/profileQuestions';

interface Props {
  values: { hardExperience: string; overcomingMethod: string; teamRole: string };
  onChange: (values: { hardExperience: string; overcomingMethod: string; teamRole: string }) => void;
}

const BehaviorQuestion: React.FC<Props> = ({ values, onChange }) => {
  const questions = [
    { key: 'hardExperience' as const, ...behaviorQuestions.hardExperience },
    { key: 'overcomingMethod' as const, ...behaviorQuestions.overcomingMethod },
    { key: 'teamRole' as const, ...behaviorQuestions.teamRole },
  ];

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
        行動特性
      </Typography>
      <Typography variant="body2" sx={{ mb: 3, color: '#666' }}>
        あなたの行動パターンを教えてください
      </Typography>

      {questions.map(({ key, question, options }) => (
        <Box key={key} sx={{ mb: 4 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1.5 }}>
            {question}
          </Typography>
          <FormControl>
            <RadioGroup
              value={values[key]}
              onChange={(e) => onChange({ ...values, [key]: e.target.value })}
            >
              {options.map((option) => (
                <FormControlLabel
                  key={option}
                  value={option}
                  control={<Radio />}
                  label={option}
                  sx={{ mb: 0.5 }}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </Box>
      ))}
    </Box>
  );
};

export default BehaviorQuestion;
